import { Color, stringifyColor } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC } from "react";
import styles from "./color-cell.module.css";

export const ColorCell: FC<Color> = (color: Color) => {
  const { red, green, blue, alpha } = color;
  const rgba = [red, green, blue, alpha / 255].join(",");
  const backgroundColor = `rgba(${rgba})`;
  return (
    <div className={styles.container}>
      <div className={styles.view} style={{ backgroundColor }}></div>
      <div>{stringifyColor(color)}</div>
    </div>
  );
};
